function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/* eslint complexity: ["error", 7] */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import FlagDropdown from '../FlagDropdown/FlagDropdown';
import PhoneField from '../PhoneField/PhoneField';
import FlagData from './phoneNumberData.json';
import "./InputTel.css";
/* istanbul ignore next */

var noop = function noop() {};

var InputTel = /*#__PURE__*/function (_Component) {
  _inheritsLoose(InputTel, _Component);

  function InputTel(props) {
    var _this;

    _this = _Component.call(this, props) || this; // create a shallow copy of each FlagData object for each instance of the input tel component

    _this.handleCountryCodeChange = function (e) {
      if (!e || !e.target || !e.target.value) {
        return;
      } // React pools events and reuses the object so save the value in case
      // it gets overwritten.


      var cc = e.target.value;
      var countryData = _this.flagData[cc];

      if (countryData) {
        countryData.cc = cc;

        _this.setState({
          phoneCode: countryData.phoneCode,
          phoneMasks: countryData.masks
        });

        _this.phoneField.focus();

        _this.props.onCountryCodeChange(e, countryData);
      }
    };

    _this.setPhoneFieldRef = function (ref) {
      _this.phoneField = ref;
    };

    _this.flagData = Object.keys(FlagData).reduce(function (data, key) {
      var obj = _extends({}, FlagData[key]);

      data[key] = obj;
      return data;
    }, {});

    _this.mergeFlagData(props.countryCodes);

    var _countryData = _this.getCountryData(props.countryCode);

    _this.state = {
      phoneCode: _countryData ? _countryData.phoneCode : '1',
      phoneMasks: _countryData ? _countryData.masks : []
    };
    return _this;
  }

  var _proto = InputTel.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var didCountryCodePropsChange = this.compareCountryCodeProps(this.props);
    var countryData = this.getCountryData(this.props.countryCode);
    var phoneCode = countryData ? countryData.phoneCode : '1';

    if (didCountryCodePropsChange) {
      this.mergeFlagData(this.props.countryCodes);
    }

    if (phoneCode !== prevState.phoneCode) {
      this.setState({
        phoneCode: countryData ? countryData.phoneCode : '1',
        phoneMasks: countryData ? countryData.masks : []
      });
    }
  } // check to see if any of the values in props.countryCodes have changed. If so, will have to re-merge this.flagData
  ;

  _proto.compareCountryCodeProps = function compareCountryCodeProps(nextProps) {
    var _this2 = this;

    return nextProps && nextProps.countryCodes && Object.keys(nextProps.countryCodes).some(function (code) {
      var nextCountryName = nextProps.countryCodes[code];
      var currentCountry = _this2.flagData[code];
      return nextCountryName && currentCountry && nextCountryName !== currentCountry.name;
    });
  };

  _proto.getCountryData = function getCountryData(countryCode) {
    var countryData = this.flagData[countryCode];

    if (!countryCode || !countryData) {
      this.props.onError(new Error('Invalid country code'));
      return this.flagData.default;
    }

    return countryData;
  };

  // find the object from this.flagData array that has the same country code as the country code passed in this.props.countryCodes
  // then replace the name value for the matching object with the name passed in in this.props.countryCodes
  _proto.mergeFlagData = function mergeFlagData(countryCodes) {
    var _this3 = this;

    Object.keys(countryCodes).map(function (code) {
      var matchingCountryObject = _this3.flagData[code];

      if (matchingCountryObject) {
        matchingCountryObject.name = countryCodes[code];
      }
    });
    this.dropdownItems = this.buildSortedCountryItems(this.flagData);
  } // sort the countries alphabetically by name
  ;

  _proto.buildSortedCountryItems = function buildSortedCountryItems(flagData) {
    return Object.keys(flagData).sort(function (a, b) {
      // Since object keys are unique, there's no possibility of the keys
      // being equal. If a is not less than it is greater than b.
      return flagData[a].name.toUpperCase() < flagData[b].name.toUpperCase() ? -1 : 1;
    }).map(function (cc) {
      var data = flagData[cc];
      return {
        value: cc,
        label: data.name + " (+" + data.phoneCode + ")"
      };
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        id = _this$props.id,
        phoneNumber = _this$props.phoneNumber,
        labels = _this$props.labels,
        errorMsg = _this$props.errorMsg,
        helpText = _this$props.helpText,
        onPhoneChange = _this$props.onPhoneChange,
        onPhoneFocus = _this$props.onPhoneFocus,
        onPhoneBlur = _this$props.onPhoneBlur,
        showCountrySelect = _this$props.showCountrySelect;
    var containerClassName = classNames(this.props.className, {
      'react-input-tel': true,
      'input-group': true
    });
    return /*#__PURE__*/React.createElement("div", {
      className: containerClassName
    }, showCountrySelect && /*#__PURE__*/React.createElement(FlagDropdown, {
      id: id + "__dropdown",
      phoneCode: this.state.phoneCode,
      countryCode: this.props.countryCode,
      items: this.dropdownItems,
      onChange: this.handleCountryCodeChange,
      labels: labels
    }), /*#__PURE__*/React.createElement(PhoneField, {
      id: id + "__input",
      phoneCode: this.state.phoneCode,
      labels: labels,
      masks: this.state.phoneMasks,
      phoneNumber: phoneNumber,
      helpText: helpText,
      errorMsg: errorMsg,
      onChange: onPhoneChange,
      onFocus: onPhoneFocus,
      onBlur: onPhoneBlur,
      showCountrySelect: showCountrySelect,
      ref: this.setPhoneFieldRef
    }));
  };

  return InputTel;
}(Component);

InputTel.propTypes = {
  /** id attribute for form field */
  id: PropTypes.string.isRequired,

  /** The phone number to populate the input field */
  phoneNumber: PropTypes.string,

  /** The country code of the flag you want displayed initially. */
  countryCode: PropTypes.string,

  /** Boolean that allows consuming app to NOT display the Country Code dropdown. */
  showCountrySelect: PropTypes.bool,

  /** When populated with a string, this will turn the border red and display a validation error beneath the input. */
  errorMsg: PropTypes.string,

  /** When populated with a string, this will display help text beneath the input. */
  helpText: PropTypes.string,

  /** Function that gets called when the user selects a new country from the dropdown. This function should set the value of countryCode in your store. */
  onCountryCodeChange: PropTypes.func,

  /**
   * Function that gets called every time the user types in the input field.
   *  This function should set the value of phoneNumber in your store. This
   *  callback provides the event object and a phoneObject that includes
   *  {raw: (string) unformatted phone number, formatted: (string) formatted phone number,
   *  phoneCode: (string) phone code, isValid: (boolean) whether the phone number is valid}.
   */
  onPhoneChange: PropTypes.func,

  /**
   * Function called when the input field gets focus. Callback signature:
   *  `function(event, phoneObject)` where phoneObject provides the current
   *  state of the phone field and has the same shape as the phoneObject
   *  received in the onPhoneChange handler.
   */
  onPhoneFocus: PropTypes.func,

  /**
   * Function called when the input field loses focus. Callback signature:
   *  `function(event, phoneObject)` where phoneObject provides the current
   *  state of the phone field and has the same shape as the phoneObject
   *  received in the onPhoneChange handler.
   */
  onPhoneBlur: PropTypes.func,

  /**
   * Function called when an error occurs displaying the specified data.
   * Currently, this is only invoked if the specified `countryCode` is not found.
   */
  onError: PropTypes.func,

  /** Translations for the component. */
  labels: PropTypes.shape({
    phoneNumber: PropTypes.string,
    countryCode: PropTypes.string
  }),

  /** Translations for the countries with the key as the country code and the value as the country name. */
  countryCodes: PropTypes.objectOf(PropTypes.string)
};
InputTel.defaultProps = {
  id: 'react-input-tel',
  phoneNumber: '',
  countryCode: 'us',
  showCountrySelect: true,
  errorMsg: '',
  helpText: '',
  onCountryCodeChange: noop,
  onPhoneChange: noop,
  onPhoneFocus: noop,
  onPhoneBlur: noop,
  onError: noop,
  labels: {
    phoneNumber: 'Phone Number',
    countryCode: 'Country Code'
  },
  countryCodes: {}
};
export default InputTel;
//# sourceMappingURL=InputTel.js.map